import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { signOut } from '@aws-amplify/auth';
import { resetAppState } from '../../store/store';
import { setAuthLoading } from '../../store/authSlice';
import { clearStorage } from '../../utils/clearStorageHelper';
import { disconnectWhatsAppSocket } from '../../hooks/useWhatsAppSocket';
import { setGlobalWhatsAppMode } from '../../hooks/useWhatsAppMode';
import DialogBox from '../../components/shared/dialogs/DialogBox';

const Logout = (props) => {
    const { id, color, icon, navName, open } = props;
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [isDialogOpen, setIsDialogOpen] = useState(false);

    const handleOpenDialog = () => {
        setIsDialogOpen(true);
    };

    const handleCloseDialog = () => {
        setIsDialogOpen(false);
    };

    const handleLogoutConfirm = async () => {
        try {
            await signOut();
        } catch (error) {
            console.error('Error signing out: ', error);
        } finally {
            setGlobalWhatsAppMode('signIn');
            disconnectWhatsAppSocket();
            clearStorage();
            dispatch(resetAppState());
            dispatch(setAuthLoading(false));
            navigate('/', { replace: true });
        }
    };

    return (
        <>
            <button
                key={id}
                onClick={handleOpenDialog}
                className="flex items-center gap-3 w-full px-2 py-2.5 rounded-lg text-sm font-medium transition-all duration-200 cursor-pointer hover:text-white hover:bg-white/5"
                style={{ color: color }}
            >
                <span className="text-5xl flex items-center justify-center w-5 h-5 flex-shrink-0">
                    {icon}
                </span>
                {open && (
                    <span className="whitespace-nowrap text-ellipsis overflow-hidden">
                        {navName}
                    </span>
                )}
            </button>
            <DialogBox
                dialog_title="Confirm Sign Out"
                dialog_body="Are you sure you want to sign out?"
                cancelButtonName="Cancel"
                SaveButtonName="Sign Out"
                saveButtonOnclick={handleLogoutConfirm}
                open={isDialogOpen}
                onClose={handleCloseDialog}
                saveButtonVariant="solid"
                saveButtonColor="red"
            />
        </>
    );
};

export default Logout;